import find from 'lodash/find';
import uniq from 'lodash/uniq';
import isEmpty from 'lodash/isEmpty';

import mapRecurlySkus from 'src/common/utils/subscription/mapZuoraSkus';
import { getOauthPartnerId } from 'src/common/components/auth/oauthProvider/getPartnerParams';

import {
  getDefaultSubscribeSkus,
  getDefaultRenewSkus,
  getPartnerSkus,
} from 'src/common/utils/subscription/getSkus';

import parseQuery from '../queryString/parse';
import { SELECTED_SKU_QUERY_PARAM } from '../../constants/queryParams';

export function findProductBySku(products, sku) {
  return find(products, (p) => p.sku === sku);
}

export function getSSFromQuery(location) {
  const query = location?.query || parseQuery(location?.search || '');

  return query?.[SELECTED_SKU_QUERY_PARAM];
}

export function getSkuFromQuery(location) {
  const query =
    typeof location?.query === 'object'
      ? location?.query
      : parseQuery(location?.search || '');
  let sku = query?.sku;
  sku = Array.isArray(sku) ? sku : sku?.split(',');
  const subscribeSkus = sku ? mapRecurlySkus(sku) : [];
  return uniq(subscribeSkus);
}

export function getDefaultSkus(location, config, isRenew) {
  const partnerId = getOauthPartnerId(location);
  const defaultSkus = isRenew
    ? getDefaultRenewSkus(config)
    : getDefaultSubscribeSkus(config);
  return partnerId
    ? getPartnerSkus(config, partnerId) || defaultSkus
    : defaultSkus;
}

// reconcileSKUQueryParam is a helper function which provides support for multiple sku queryParams (ss && sku)
// it seems that the app uses both versions, this helper extends flexibility to help support different deeplink formats
export function reconcileSKUQueryParam(location) {
  const skuFromQuery = getSkuFromQuery(location);

  return !isEmpty(skuFromQuery) ? skuFromQuery[0] : getSSFromQuery(location);
}

export function selectProductFromQuery(products, location) {
  const sku = reconcileSKUQueryParam(location);

  return findProductBySku(products, sku?.toLowerCase());
}
